import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failedStrategies = [{
  title: 'Publicar en redes sociales y esperar',
  description: 'Publicar en Instagram y Facebook esperando que alguien te pregunte precios es una estrategia basada en la suerte.'
}, {
  title: 'Crear tiendas complejas sin tráfico',
  description: 'Crear tiendas complejas sin tener tráfico validado solo te hace perder tiempo y dinero en suscripciones.'
}, {
  title: 'Ofrecer descuentos desesperados',
  description: 'Ofrecer descuentos desesperados sin una estructura de urgencia real solo devalúa tu trabajo.'
}, {
  title: 'Cursos genéricos de marketing',
  description: 'Los cursos genéricos de marketing digital no entienden la urgencia de quien necesita pagar facturas esta semana.'
}];
export function WhyDidntWork() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-[#faf8f5]" data-id="element-152">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-6xl" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-154">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1e3a8a] text-center" data-id="element-155">
            Por qué lo que intentaste no funcionó
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-156">
            {failedStrategies.map((strategy, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-500 hover:shadow-lg transition-shadow" data-id="element-157">
                <div className="flex items-start gap-4" data-id="element-158">
                  <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-159" />
                  <div className="space-y-2" data-id="element-160">
                    <h3 className="text-xl font-bold text-[#1e3a8a]" data-id="element-161">
                      {strategy.title}
                    </h3>
                    <p className="text-gray-700" data-id="element-162">{strategy.description}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}